<template>
  <div class="home"  v-title :data-title="title">
    <bannera />
    <div class="box">
      <contenta /> 
    </div>
    <footera /> 
  </div>
</template>

<script>
import "../../../../common/js/pcRem.js";
import "../../../../common/css/common.css";
import Base64 from "../../../../common/js/base64.js";

import bannera from "../../components/pc/banner.vue";
import contenta from "../../components/pc/content.vue";
import footera from "../../components/pc/footer.vue";
export default {
  name: "App",
  components: {
    bannera,
    contenta,
    footera
  },
  data() {
    return {
     title:'中文在线优质正版内容 助力全国信息素养大赛顺利启动!'
    }
    
  },
  created() {
    // if (window.location.host == "sxdc.w.chineseall.cn") {
    //   this.title = "来书香东城“赛龙舟”，读点好书更出“粽”";
    // } else {
    //   this.title = "来书香中国“赛龙舟”，读点好书更出“粽”";
    // }
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.home {
  margin: auto;
 
}
</style>

